import React, { Component } from 'react'
import { Table } from 'react-bootstrap'

class Kennis extends Component {
    constructor(props) {
        super(props)
        this.getEducationsKnown = this.getEducationsKnown.bind(this)
        this.getTotalPoints = this.getTotalPoints.bind(this)
    }

    getEducationsKnown() {
        let data = this.props.data
        return data && data.length > 0 ? data.map((e, index) => {
            return <tr key={index}>
                <td>{e.type}</td>
                <td>{e.level}</td>
                <td>{e.institution}</td>
                <td>{e.name}</td>
                <td>{e.city}</td>
                <td>{e.endYear}</td>
                <td>{e.diploma}</td>
                <td>{e.typeCursus}</td>
                <td>{e.hours}</td>
                <td>{e.agerond}</td>
                <td>{e.points}</td>
            </tr>
        }) : null
    }

    getTotalPoints() {
        let data = this.props.data
        return data && data.length > 0 ?
            <tr>
                <td colSpan='10'><strong>Totaal ke´s</strong></td>
                <td><strong>{data.map(t => { return t.points }).reduce((acc, val) => acc + val)}</strong></td>
            </tr> : null
    }

    render() {
        return (
            <div className="rapport">
                <h5><strong>{this.props.permanent ? "Permanente kennis" : "Kennis"}</strong></h5>
                <Table responsive bordered className="kennis">
                    <thead>
                        <tr>
                            <th>type</th>
                            <th>niveau</th>
                            <th>instelling</th>
                            <th>opleiding</th>
                            <th>plaats</th>
                            <th>afgerond in</th>
                            <th>diploma</th>
                            <th>type cursus</th>
                            <th>aantal lesuren</th>
                            <th>afgerond met toets</th>
                            <th>ke's</th>
                        </tr>
                    </thead>

                    <tbody>
                        {this.getEducationsKnown()}
                        {this.getTotalPoints()}
                    </tbody>
                </Table>
            </div>)

    }
}

export default Kennis;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Rapport/Kennis.js